import * as angular from "angular";
import { IGeofence } from "@interfaces/IGeofences";
import "./geofenceDetailsInfo.scss";

interface IGeofenceDetailsInfoBindings {
    geofence: IGeofence;   
}

class GeofenceDetailsInfoComponentController implements angular.IComponentController, IGeofenceDetailsInfoBindings {
    geofence: IGeofence;
    constructor() { }
}

export class GeofenceDetailsInfoComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;

    constructor() {
        this.bindings = {
            geofence: "<",
        };

        this.controller = GeofenceDetailsInfoComponentController;
        this.template = require("./geofenceDetailsInfo.html");
    }
}
